module.exports = __webpack_public_path__ + "img/code11.211f422d.png";